// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let TailwindVariants = require("../../../../v5/bindings/TailwindVariants.bs.js");
let TailwindVariants$1 = require("tailwind-variants");

let baseInputStyles = "border border-solid bg-white border-zinc-300 \n    text-black w-full px-2 py-1.5 shadow-none leading-5 appearance-none \n    duration-150 m-0 rounded-sm vertical-align-middle";

let inputStyles = TailwindVariants$1.tv({
  extend: TailwindVariants.Utils.focusRing,
  base: baseInputStyles,
  variants: {
    status: {
      error: "border-tan-error-500",
      ok: "border-tan-success"
    },
    isFocused: {
      false: "",
      true: "border-tan-focused-border"
    },
    isInvalid: {
      true: "border-tan-error-500"
    },
    isDisabled: {
      true: "border-zinc-300 hover:border-zinc-400"
    }
  }
});

exports.baseInputStyles = baseInputStyles;
exports.inputStyles = inputStyles;
/* inputStyles Not a pure module */
